require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/maps/MapBaidu.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/maps/MapBaidu.legacy.js
// module id = 660
// module chunks = 31